import { render, staticRenderFns } from "./FeedbackScoreList.vue?vue&type=template&id=514cd095&"
import script from "./FeedbackScoreList.vue?vue&type=script&lang=js&"
export * from "./FeedbackScoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports